import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';

import TaxReceiptPanel from './TaxReceiptPanelContainer';

class TaxReceiptTabRoute extends Component {

  render() {
    const { locale, transaction, campaignId, match } = this.props;
    const _campaignId = campaignId || match.params.campaignID;
    const _transactionId =  transaction && transaction.id || match.params.transactionID;
    const path = `/${locale}/d/${
      _campaignId
        ? `campaigns/${_campaignId}/`
        : ''
    }transactions/${_transactionId}/donationreceipt`;

    return (
      <Route exact path={path} render={(props) => <TaxReceiptPanel {...this.props} />} />
    );
  }

}

TaxReceiptTabRoute.defaultProps = {
  campaignId: null,
  transaction: null
}

TaxReceiptTabRoute.propTypes = {
  locale: PropTypes.string.isRequired,
  transaction: PropTypes.object,
  campaignId: PropTypes.number,
  dispatch: PropTypes.func
};

export default TaxReceiptTabRoute;
